import apiV2 from '../../api/v2';

export interface DeliverAlignersInput {
    chartNotes: string;
    acknowledged: boolean;
}

export interface StartMonitoringParams {
    // Omitted when monitoring is paused: the backend resumes it with its
    // existing quickstart instead of starting a new one.
    quickstart?: string;
    quickstartName?: string;
    currentAligner: number;
    totalAligner: number;
}

export async function startMonitoringWorkflow(
    patientId: string,
    params: StartMonitoringParams
): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/in-treatment/start-monitoring`,
        params
    );
}

export async function deliverAligners(
    patientId: string,
    input: DeliverAlignersInput
): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/manufacturing/delivered`,
        input
    );
}

export async function deliverRefinementAligners(
    patientId: string,
    input: DeliverAlignersInput
): Promise<void> {
    await apiV2.post(
        `/patients/${encodeURIComponent(patientId)}/workflow/refinement/manufacturing/delivered`,
        input
    );
}
